import * as React from "react";
import "../index.css";
// import "../Modules/protect/protect.css";
import { Col, Container, Image, Row } from "react-bootstrap";
import Highlights from "../Modules/protect/Highlights";
import Product from "../Modules/home/Product";
import AudioShowcase from "../Modules/protect/AudioShowcase";
import ImageHighlights from "../Modules/protect/ImageHighlights";
import Testimonials from "../Modules/home/testimonials";
import Difference from "../Modules/Difference";
import Process from "../Modules/protect/Process";
import { Helmet } from "react-helmet";
import Teaser from "../Modules/protect/Teaser";
import Footer from "../Modules/Footer";
import NavigationBar from "../Modules/NavigationBar";
import Hero from "../Modules/home/Hero";
import ProductShowcase from "../Modules/ProductShowcase";
import UniqueSellingPoint from "../Modules/UniqueSellingPoint";
import Spacer from "../Modules/Spacer";

export default function Redux() {
	return (
		<>
			<Helmet>
				<title>{"EarsOnly | Redux"}</title>
			</Helmet>
			<NavigationBar />

			<ProductShowcase
				redux
				title="/images/logos/EarsOnlyreduxBLACK.png"
				text="Custom-Fit Hearing protection. Redux earplugs are engineered for both professionals and dedicated enthusiasts who demand high performance and protection. "
				img="images/cradle_and_buds/REDUX.png"
				backgroundImage1="images/lifestyle/LifestyleMOTORCYCLE.jpg"
				backgroundImage2="images/lifestyle/LifestyleWORKER.jpg"
				backgroundImage3="images/lifestyle/LifestyleMUSIC.jpg"
			/>

			<Container className="container-padding" >
				<h2 className="difference-title">What makes EarsOnly <br />Redux different?</h2>
				<Spacer />
				<Highlights
					largeRow={4}

					highlights={[
						{
							title: "Dutch-made Quality",
							icon: "images/highlighticons/Dutch-made.png",
							bullets: ["Designed and produced in the Netherlands"],
						},
						{
							title: "Earbuds designed for maximum comfort",
							icon: "images/highlighticons/Custom-fit.png",
							bullets: ["Tailored to your ear and crafted with additive manufacturing, ensuring a comfortable and secure fit."],
						},
						{
							title: "Hearing Protection",
							icon: "images/highlighticons/Protection.png",
							bullets: ["Noise Protection Level up to 19dB, 28dB, 30dB or 33dB"],
						},
						{
							title: "Lasting Safety",
							icon: "images/highlighticons/Safety.png",
							bullets: ["Available in various colors.", "All filters are X-ray & Metal detectable", "Separately available, Quick-release cord", "Hygienic, Easy-clean material", "Bio-compatible material"],
						},
						
					]}
				/>
				<Spacer />
				<Row className='usp-card d-flex align-items-center' xs={1} sm={1} md={2}>
					<Col className='usp-icon-text'>
						<Image src="/images/cradle_and_buds/Redux color options.png" width={"70%"} />
					</Col>
					<Col className="usp-text" style={{ paddingTop: "2em" }} md={4}>
						{"Redux passive hearing protection comes in various materials, styles, colors, and protection levels. Contact us for a tailored proposal."}
					</Col>
				</Row>
				<Spacer />

				<h2 className="difference-title">Exchangeable filters</h2>

				<Highlights
					filters
					largeRow={4}

					highlights={[
						{
							title: "White 20",
							icon: "/images/cradle_and_buds/Redux-Filter_White.png",
							bullets: [
								"Festivals ",
								"Concerts  ",
								"Musicians  ",
								"Motorcycling  ",
								"Communication  ",
								"Water sports  ",
							],
						},
						{
							title: "Yellow 20",
							icon: "/images/cradle_and_buds/Redux-Filter_Yellow.png",
							bullets: [
								"Low noise Industries  ",
								"DIY enthusiasts  ",
								"Festivals  ",
								"Concerts  ",
								"Musicians  ",
								"Motorcycling  ",
							],
						},
						{
							title: "Red 25",
							icon: "/images/cradle_and_buds/Redux-Filter_Red.png",
							bullets: [
								"Medium noise Industries  ",
								"DIY enthusiasts  ",
								"Motorcycling  ",
								"Traveling  ",
								"Concentrate  ",
							],
						},
						{
							title: "Purple 30",
							icon: "/images/cradle_and_buds/Redux-Filter_Purple.png",
							bullets: [
								"High noise Industries  ",
								"DIY enthusiasts  ",
								"Traveling  ",
								"Concentrate  ",
							],
						},

					]}
				/>
				<Spacer />
			</Container>
			<Footer />
		</>
	);
}
